import axios from "axios";
import { UTILS, MESSENGER } from "../../endpointsConst";

const MessengerDropdownService = {};

MessengerDropdownService.getMessengers = () =>
    axios.get(UTILS + MESSENGER).catch((e) => {
        return new Error(e.response.status);
    });

export { MessengerDropdownService };
